const e = "Cuenta", a = "Saldo de la cuenta", o = "Descripción de tu cuenta", n = "Id. de cuenta", t = "Suma", r = "Ajustes", s = "Cantidad", i = "y", c = "Aplicar", d = "Volver", l = "Cuenta de saldo", u = "ID de cuenta de saldo", p = "Reservado", m = "Capturado", f = "Categoría", g = "Contracargos", h = "Cerrar", y = "Contacta con el servicio de soporte", v = "Contacta con el servicio de soporte para obtener ayuda.", b = "Ponte en contacto con el servicio de asistencia para obtener ayuda y compartir el código de error %{requestId}", C = "Copiado", T = "Texto", P = "Correcciones", R = "Divisa", A = "Fecha", N = "Intervalo de fechas", S = "Descripción", F = "Descartar", D = "Descargar", O = "Descargando", I = "Correo electrónico", L = "No se ha encontrado la entidad", x = "No se ha encontrado la transacción para el titular especificado", q = "Tasas", w = "Archivo", E = "Barra de filtro", B = "Desde", W = "Completo", k = "Fondos capturados", M = "Volver", z = "Subvención concedida", V = "Reembolsos de la subvención", U = "Ocultar contenido", j = "Documento de identidad", H = "Campo incompleto", Y = "En curso", _ = "Cargando", G = "máx.", X = "min", Q = "Móvil", Z = "Pago neto", J = "Próximos pagos", K = "Sin datos", $ = "No se permiten números negativos", ee = "No se ha encontrado ningún pago", ae = "No se ha encontrado ningún informe", oe = "No se han encontrado transacciones", ne = "Otro/a", te = "Navegación por páginas", re = "Parcial", se = "ID de pago", ie = "Método de pago", ce = "Detalles de pago", de = "La información de pago se genera todos los días a medianoche, hora UTC.", le = "Pagos", ue = "Pendiente", pe = "Vuelve más tarde.", me = "Ponte en contacto con soporte para obtener ayuda.", fe = "Ponte en contacto con soporte", ge = "ID de referencia", he = "Actualizar", ye = "Reembolsos", ve = "Pago de la devolución", be = "No hemos podido procesar la devolución. Inténtalo de nuevo más tarde.", Ce = "Se ha producido un error.", Te = "Tu cliente recibirá el dinero en un máximo de 40 días. Cuando la devolución se complete de forma correcta, verás una nueva transacción de devolución en tu lista.", Pe = "¡Se ha enviado la devolución!", Re = "Importe a devolver", Ae = "Las devoluciones pueden tardar hasta 40 días según el método de pago. Las tarifas están incluidas.", Ne = "Devuelve %{amount}", Se = "Motivo de la devolución", Fe = "Referencia", De = "Cantidad restante", Oe = "Informe", Ie = "Los informes se generan cada día a medianoche, hora UTC.", Le = "Informes", xe = "Restablecer", qe = "Invertido", we = "Se ha producido un error.", Ee = "Se ha producido un error. Prueba a actualizar la página o inténtalo más tarde.", Be = "Estado", We = "Lista estructurada", ke = "Sustracciones", Me = "Suma de los pagos del mismo día", ze = "Pestañas", Ve = "El código de error es %{requestId}", Ue = "Sin resultados", je = "Faltan faltan campos obligatorios en la solicitud o esta contiene datos no válidos.", He = "Se ha producido un error inesperado", Ye = "La cuenta de saldo seleccionada es incorrecta", _e = "Zona horaria", Ge = "Hasta", Xe = "Fondos entrantes totales", Qe = "Fondos salientes totales", Ze = 'El valor "Hasta" debe ser igual o mayor que el valor "Desde"', Je = "Detalles de la transacción", Ke = "Transacciones", $e = "Resumen de transacciones", ea = "Tipo de transacción", aa = "Transferencias", oa = "Prueba con una búsqueda diferente o restablece los filtros para que lo intentemos de nuevo.", na = "Prueba a actualizar la página o inténtalo más tarde.", ta = "Cantidad", ra = "Tipo", sa = "Valor", ia = "No hemos podido cargar el listado de pagos.", ca = "No hemos podido cargar el listado de informes.", da = "No hemos podido cargar el listado de transacciones.", la = "No hemos podido cargar tus cuentas de saldo.", ua = "No hemos podido cargar tus pagos.", pa = "No hemos podido cargar tus informes.", ma = "No hemos podido cargar tus transacciones.", fa = {
  account: e,
  accountBalance: a,
  accountDescription: o,
  accountID: n,
  additions: t,
  adjustments: r,
  amount: s,
  and: i,
  apply: c,
  back: d,
  balanceAccount: l,
  balanceAccountId: u,
  Booked: p,
  "button.clearAll": "Borrar todo",
  "calendar.controls": "Controles de navegación del calendario",
  "calendar.nextMonth": "Mes siguiente",
  "calendar.previousMonth": "Mes anterior",
  "calendar.timezone": "La zona horaria está establecida en: %{offset} GMT (%{time})",
  "capital.accountIsInactive": "Tu cuenta está inactiva",
  "capital.actionNeeded": "Acción necesaria",
  "capital.bankAccountDetails": "Detalles de la cuenta bancaria",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Número de cuenta",
  "capital.bankCountryOrRegion": "País o región",
  "capital.bankRoutingNumber": "Número de ruta",
  "capital.bankSortCode": "Código de destino",
  "capital.businessFinancing": "Financiación de empresas",
  "capital.businessFinancingOffer": "Oferta de financiación para tu negocio",
  "capital.businessFinancingSummary": "Resumen de financiación para empresas",
  "capital.closed": "Cerrada",
  "capital.couldNotContinueWithTheOffer": "No hemos podido continuar con la oferta.",
  "capital.couldNotLoadFinancialOffers": "No hemos podido cargar las ofertas financieras.",
  "capital.dailyRepaymentRate": "Tasa de reembolso diaria",
  "capital.daysAndDaysLeft": "%{days} días (quedan %{daysLeft} días)",
  "capital.expectedRepaymentPeriod": "Plazo de reembolso previsto",
  "capital.failed": "Error",
  "capital.fees": "Tasas",
  "capital.fullyRepaid": "Reembolso completado",
  "capital.goToTermsAndConditions": "Consulta los términos y condiciones",
  "capital.grantID": "Id. de subvención",
  "capital.howMuchMoneyDoYouNeed": "¿Cuánto dinero necesitas?",
  "capital.inProgress": "En curso",
  "capital.legalSubtitleAU": "Adyen Capital es proporcionado por Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Los préstamos los emite Adyen N.V.",
  "capital.legalSubtitleGB": "Los préstamos son emitidos por Adyen N.V., representada por su sucursal en Londres.",
  "capital.legalSubtitleUS": "Los préstamos son emitidos por Adyen N.V. Sucursal de San Francisco y están sujetos a la aprobación de crédito.",
  "capital.maximumRepaymentPeriod": "Plazo máximo de reembolso",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Reembolso mínimo cada %{days} días para devolver la financiación a tiempo",
  "capital.needSomeExtraMoney": "¿Necesitas dinero extra?",
  "capital.offerLegalNoticeDescriptionUS": "Si su solicitud de crédito comercial es rechazada, usted tiene derecho a una declaración por escrito de las razones de rechazo. Para obtener la declaración, debe comunicarse con Adyen Credit Support Team (%{email}), dentro de 60 días a partir de la fecha de esta carta. Le enviaremos una declaración escrita de las razones de rechazo dentro de 30 días a partir de la fecha de recibir su petición. %{break} Aviso: La “Federal Equal Credit Opportunity Act” (Ley Federal de Igualdad de Oportunidades de Crédito) prohíbe a los acreedores de discriminar a un solicitante por motivos de raza, color, religión, origen nacional, sexo, estado civil, edad (siempre y cuando el solicitante de crédito esté en capacidad de firmar un contrato vinculante); porque los ingresos del solicitante, en su totalidad o en parte, provengan de algún programa de asistencia pública; o porque el solicitante haya ejercido de buena fe, cualquier derecho en virtud de la “Consumer Credit Protection Act” (Ley de Protección de Crédito al Consumidor). La agencia federal que administra el cumplimiento de esta ley, con respecto a este acreedor, es Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Adyen N.V. - San Francisco Branch %{break} 505 Brannan Street, San Francisco, CA 94107",
  "capital.oneMonth": "1 mes",
  "capital.pending": "Pendiente",
  "capital.primaryAccount": "Cuenta principal",
  "capital.remaining": "Pendiente",
  "capital.remainingAmount": "Cantidad restante",
  "capital.remainingFees": "Cuotas restantes",
  "capital.repaid": "Reembolsado",
  "capital.repaidAmount": "Cantidad reembolsada",
  "capital.repaidFees": "Cuotas reembolsadas",
  "capital.repaymentBalanceInfo": "La cantidad que te queda por pagar, incluidas las comisiones, es de %{amount}",
  "capital.repaymentThreshold": "Umbral de reembolso",
  "capital.requestedFunds": "Fondos solicitados",
  "capital.requestFunds": "Solicitar fondos",
  "capital.requesting": "Solicitando",
  "capital.reviewOffer": "Revisar oferta",
  "capital.revoked": "Revocado",
  "capital.seeNewOffer": "Consulta la nueva oferta",
  "capital.seeOptions": "Ver opciones",
  "capital.sendRepayment": "Enviar el reembolso",
  "capital.sendRepaymentNotice": "La transferencia bancaria adicional que se ha hecho para el reembolso de tu préstamo podría tardar entre 2 y 3 días hábiles en reflejarse en tu cuenta del préstamo.",
  "capital.sendRepaymentSubtitle": "Transfiere dinero a esta cuenta bancaria para reembolsar tu préstamo en parte o en su totalidad.",
  "capital.signTermsAndConditionsToReceiveFunds": "Firma los términos y condiciones para recibir tus fondos.",
  "capital.signTheTermsToReceiveYourFunds": "Firma los términos para recibir tus fondos",
  "capital.termEnds": "Fin del plazo: ",
  "capital.thereIsNoPrimaryAccountConfigured": "No se ha configurado ninguna cuenta principal",
  "capital.thisOfferExpiresOn": "Esta oferta caduca el %{date}.",
  "capital.totalFees": "Total de cuotas",
  "capital.totalRepaymentAmount": "Importe total del reembolso",
  "capital.unsupportedRegionDescription": "La financiación empresarial aún no está disponible en tu región, pero vuelve a consultar aquí para ver si hay alguna oferta.",
  "capital.unsupportedRegionTitle": "¡Mantente al tanto!",
  "capital.weCouldNotContinueWithTheOffer": "No hemos podido continuar con la oferta.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "No hemos podido continuar con la oferta. Contacta con el servicio de soporte para obtener ayuda.",
  "capital.weCouldNotLoadFinancialOffers": "No hemos podido cargar las ofertas financieras.",
  "capital.weCouldNotProcessThisRequestTryAgain": "No hemos podido procesar esta solicitud. Inténtalo de nuevo con una nueva oferta.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Hemos recibido tu solicitud y estamos trabajando en ella. Vuelve pronto para informarte sobre los próximos pasos.",
  "capital.writtenOff": "Perdido",
  "capital.xDays": "%{days} días",
  "capital.xMonths": "%{months} meses",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Aceptaste estos fondos, pero luego los devolviste",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Aceptaste estos fondos, pero no los reembolsaste",
  "capital.youAreRequestingFundingOf": "Estás solicitando una financiación de",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Se ha preaprobado tu solicitud para la financiación de tu negocio",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " hasta %{amount}.",
  "capital.yourRequestedFundsWere": "Los fondos que solicitaste son: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Deberías recibir los fondos dentro de un día hábil",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Deberás reembolsar un mínimo de %{amount} cada %{days} días para abonar completamente los fondos antes del %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "¡Pronto cumplirás los requisitos para una oferta financiera!",
  capture: m,
  category: f,
  chargeback: g,
  closeIconLabel: h,
  contactSupport: y,
  contactSupportForHelp: v,
  contactSupportForHelpAndShareErrorCode: b,
  copied: C,
  copy: T,
  correction: P,
  currency: R,
  date: A,
  dateRange: N,
  default: "Por defecto",
  description: S,
  dismiss: F,
  download: D,
  downloading: O,
  email: I,
  entityWasNotFound: L,
  entityWasNotFoundDetail: x,
  "error.pleaseTryAgainLater": "Inténtalo de nuevo más tarde.",
  "error.somethingWentWrongWithDownload": "Se ha producido un error con la descarga",
  "expandableCard.collapse": "Contraer",
  "expandableCard.expand": "Expandir",
  export: "Exportar",
  fee: q,
  file: w,
  "filter.date.since": "Desde %{date}",
  "filter.date.until": "Hasta %{date}",
  filterBar: E,
  "filterPlaceholder.category": "Tipo",
  "filterPlaceholder.currency": "Divisa",
  "filterPlaceholder.status": "Estado",
  from: B,
  full: W,
  fundsCaptured: k,
  goBack: M,
  grantIssued: z,
  grantRepayment: V,
  hideContent: U,
  id: j,
  incompleteField: H,
  inProgress: Y,
  loading: _,
  max: G,
  min: X,
  mobile: Q,
  netPayout: Z,
  nextPayouts: J,
  noData: K,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ae,
  noTransactionsFound: oe,
  other: ne,
  paginatedNavigation: te,
  "pagination.nextPage": "Página siguiente",
  "pagination.previousPage": "Página anterior",
  "pagination.showing": "Visible",
  partial: re,
  paymentId: se,
  paymentMethod: ie,
  payoutDetails: ce,
  payoutsNotice: de,
  payoutsTitle: le,
  Pending: ue,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: me,
  "rangePreset.custom": "Personalizadas",
  "rangePreset.last30Days": "Últimos 30 días",
  "rangePreset.last7Days": "Últimos 7 días",
  "rangePreset.lastMonth": "Mes pasado",
  "rangePreset.lastWeek": "Última semana",
  "rangePreset.thisMonth": "Este mes",
  "rangePreset.thisWeek": "Esta semana",
  "rangePreset.yearToDate": "Este año hasta la fecha",
  reachOutToSupport: fe,
  referenceID: ge,
  refresh: he,
  refund: ye,
  "refund.amountAlreadyRefunded": "Ya has reembolsado %{amount}",
  "refund.amountFailed": "Se ha producido un error al procesar la devolución de %{amount}. Actualmente no es posible devolver esta cantidad. Ponte en contacto con soporte.",
  "refund.amountInProgress": "Se está procesando la devolución parcial de %{amount}.",
  "refund.fee": "Fee (Tasa)",
  "refund.fullAmountFailed": "No es posible devolver este pago. Ponte en contacto con soporte.",
  "refund.fullAmountRefunded": "Se ha devuelto la cantidad íntegra al cliente",
  "refund.goToPayment": "Ve a Pagos",
  "refund.maximumRefundable": "Solo puedes hacer una devolución de un máximo de %{amount}",
  "refund.onlyRefundable": "Solo puedes reembolsar %{amount}",
  "refund.originalAmount": "Importe original",
  "refund.originalPayment": "Pago original",
  "refund.paymentPspReference": "Referencia PSP del pago",
  "refund.pspReference": "Referencia PSP",
  "refund.refundFee": "Comisión de devolución",
  "refund.refundPspReference": "Referencia PSP de la devolución",
  "refund.returnToRefund": "Volver a la devolución",
  "refund.theRefundIsBeingProcessed": "La devolución se está procesando.",
  refundAction: ve,
  refundActionErrorSubtitle: be,
  refundActionErrorTitle: Ce,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: Pe,
  refundAmount: Re,
  "refundAmount.excess": "No puedes superar la cantidad disponible de %{amount}",
  "refundAmount.required": "Introduce la cantidad del reembolso",
  "refunded.full": "Devolución completa",
  "refunded.partial": "Devolución parcial",
  refundNotice: Ae,
  refundPayment: Ne,
  refundReason: Se,
  "refundReason.duplicate": "Duplicar",
  "refundReason.fraudulent": "Fraude",
  "refundReason.issue_with_item_sold": "Problema con el artículo vendido",
  "refundReason.other": "Otro/a",
  "refundReason.requested_by_customer": "Solicitud del cliente",
  refundReference: Fe,
  "refundReference.placeholder": "Introduce la referencia aquí",
  remainingAmount: De,
  report: Oe,
  "reportsError.tooManyDownloads": "No hemos podido descargar todos los archivos. Vuelve a intentarlo más tarde.",
  reportsNotice: Ie,
  reportsTitle: Le,
  "reportType.payout": "Pago",
  reset: xe,
  Reversed: qe,
  "select.filter.placeholder": "Marcador de posición",
  "select.noOptionsFound": "No hay opciones que coincidan con esta búsqueda",
  somethingWentWrong: we,
  somethingWentWrongTryRefreshingOrComeBackLater: Ee,
  status: Be,
  structuredList: We,
  subtractions: ke,
  sumOfSameDayPayouts: Me,
  tabs: ze,
  theErrorCodeIs: Ve,
  thereAreNoResults: Ue,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: je,
  thereWasAnUnexpectedError: He,
  theSelectedBalanceAccountIsIncorrect: Ye,
  timezone: _e,
  to: Ge,
  "tooltip.ATM": "Dinero retirado en un cajero automático",
  "tooltip.Capital": "Dinero de una concesión de préstamo entrante o de un reembolso de préstamo saliente",
  "tooltip.Chargeback": "Dinero devuelto a un cliente después de una transacción en disputa",
  "tooltip.Correction": "Ajustes a tus fondos, incluidas reversiones de transacciones y correcciones de depósitos",
  "tooltip.Fee": "Costes de la transacción y comisiones del método de pago",
  "tooltip.Other": "Transacciones que no pertenecen a otra categoría, normalmente un ajuste",
  "tooltip.Payment": "Dinero recibido en tu cuenta de una transacción de venta",
  "tooltip.Refund": "Dinero devuelto a un cliente por una transacción reembolsada",
  "tooltip.totalIncoming": "Todo el dinero recibido en tu cuenta de acuerdo a los filtros seleccionados",
  "tooltip.totalOutgoing": "Todas las comisiones, los reembolsos, los pagos y otros cargos de acuerdo a los filtros seleccionados",
  "tooltip.Transfer": "Dinero movido entre tu cuenta y otra",
  totalIncoming: Xe,
  totalOutgoing: Qe,
  toValueShouldBeGreaterThanTheFromValue: Ze,
  transactionDetails: Je,
  transactions: Ke,
  transactionsOverviewTitle: $e,
  transactionType: ea,
  transfer: aa,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: oa,
  tryRefreshingThePageOrComeBackLater: na,
  txAmount: ta,
  "txType.ATM": "Cajero automático",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Corrección",
  "txType.Fee": "Fee (Tasa)",
  "txType.Other": "Otro/a",
  "txType.Payment": "Pago",
  "txType.Refund": "Devolución",
  "txType.Transfer": "Transferencia",
  type: ra,
  value: sa,
  weCouldNotLoadThePayoutsOverview: ia,
  weCouldNotLoadTheReportsOverview: ca,
  weCouldNotLoadTheTransactionsOverview: da,
  weCouldNotLoadYourBalanceAccounts: la,
  weCouldNotLoadYourPayouts: ua,
  weCouldNotLoadYourReports: pa,
  weCouldNotLoadYourTransactions: ma
};
export {
  p as Booked,
  ue as Pending,
  qe as Reversed,
  e as account,
  a as accountBalance,
  o as accountDescription,
  n as accountID,
  t as additions,
  r as adjustments,
  s as amount,
  i as and,
  c as apply,
  d as back,
  l as balanceAccount,
  u as balanceAccountId,
  m as capture,
  f as category,
  g as chargeback,
  h as closeIconLabel,
  y as contactSupport,
  v as contactSupportForHelp,
  b as contactSupportForHelpAndShareErrorCode,
  C as copied,
  T as copy,
  P as correction,
  R as currency,
  A as date,
  N as dateRange,
  fa as default,
  S as description,
  F as dismiss,
  D as download,
  O as downloading,
  I as email,
  L as entityWasNotFound,
  x as entityWasNotFoundDetail,
  q as fee,
  w as file,
  E as filterBar,
  B as from,
  W as full,
  k as fundsCaptured,
  M as goBack,
  z as grantIssued,
  V as grantRepayment,
  U as hideContent,
  j as id,
  Y as inProgress,
  H as incompleteField,
  _ as loading,
  G as max,
  X as min,
  Q as mobile,
  Z as netPayout,
  J as nextPayouts,
  K as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ae as noReportsFound,
  oe as noTransactionsFound,
  ne as other,
  te as paginatedNavigation,
  re as partial,
  se as paymentId,
  ie as paymentMethod,
  ce as payoutDetails,
  de as payoutsNotice,
  le as payoutsTitle,
  pe as pleaseComeBackLater,
  me as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  ge as referenceID,
  he as refresh,
  ye as refund,
  ve as refundAction,
  be as refundActionErrorSubtitle,
  Ce as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  Pe as refundActionSuccessTitle,
  Re as refundAmount,
  Ae as refundNotice,
  Ne as refundPayment,
  Se as refundReason,
  Fe as refundReference,
  De as remainingAmount,
  Oe as report,
  Ie as reportsNotice,
  Le as reportsTitle,
  xe as reset,
  we as somethingWentWrong,
  Ee as somethingWentWrongTryRefreshingOrComeBackLater,
  Be as status,
  We as structuredList,
  ke as subtractions,
  Me as sumOfSameDayPayouts,
  ze as tabs,
  Ve as theErrorCodeIs,
  je as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  Ye as theSelectedBalanceAccountIsIncorrect,
  Ue as thereAreNoResults,
  He as thereWasAnUnexpectedError,
  _e as timezone,
  Ge as to,
  Ze as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  Qe as totalOutgoing,
  Je as transactionDetails,
  ea as transactionType,
  Ke as transactions,
  $e as transactionsOverviewTitle,
  aa as transfer,
  oa as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  na as tryRefreshingThePageOrComeBackLater,
  ta as txAmount,
  ra as type,
  sa as value,
  ia as weCouldNotLoadThePayoutsOverview,
  ca as weCouldNotLoadTheReportsOverview,
  da as weCouldNotLoadTheTransactionsOverview,
  la as weCouldNotLoadYourBalanceAccounts,
  ua as weCouldNotLoadYourPayouts,
  pa as weCouldNotLoadYourReports,
  ma as weCouldNotLoadYourTransactions
};
